/**
 * @file
 * A JavaScript file for BMI Calculator.
 *
 * @copyright Copyright 2023 Palantir.net
 *
 */

(function ($,Drupal) {
  // A function for calculate your BMI when you click Calculate my BMI button.
  Drupal.behaviors.bmiCal = {
    attach(context,settings) {
      $('#bmi-caculatorButton').click(function() {
        // alert('Clicked');
        let weight = eval(document.getElementById('bmi-weight-input').value);
        /* number entered for weight */
        let height1 = eval(document.getElementById('bmi-height1').value);
        /* number entered for ft/cm */
        let height2 = eval(document.getElementById('bmi-height2').value);
        /* number entered for inches */
        let weightUnits = eval(document.getElementById('weightUnits').selectedIndex);
        /* weight units */
        let heightUnits = eval(document.getElementById('heightUnits').selectedIndex);
        /* height units */
        if (weightUnits == 0) { pounds = weight; kilograms = pounds * 0.45359237;
        } else {
          kilograms = weight; }
        if (heightUnits == 0) {
          feet = height1;
          if (height2 == null) { height2 = 0 } inches = (feet * 12) + height2; centimeters = inches * 2.54;
        } else {
          centimeters = height1;
        }
        let meters = centimeters / 100;
        let bmiRaw = kilograms / (meters * meters); var BMI = custRound(bmiRaw, 1);
        if (BMI <= 18.5) { interpretation = "You may be underweight." }
        if (BMI > 18.5 && BMI <= 25) { interpretation = "You are in a healthy weight range." }
        if (BMI > 25 && BMI <= 30) { interpretation = "You may be overweight." }
        if (BMI > 30) { interpretation = "You may be obese." }
        if (BMI > 200) { interpretation = "Such a BMI is <i>impossible." }
        if (BMI < 12) { interpretation = "Such a BMI is <i>impossible." }
        if (BMI == Infinity) { interpretation = "You forgot to enter your height." }
        if (isNaN(BMI)) { BMI = null; }
        if (BMI == null) { document.getElementById('bmi-results').style.visibility = 'hidden'; }
        else { document.getElementById('bmi-results').style.visibility = 'visible';
          document.getElementById('bodyMassIndex').innerHTML = BMI;
          document.getElementById('bmi-interpretation').innerHTML = interpretation; } })
      function custRound(x, places) {
        return (Math.round(x * Math.pow(10, places))) / Math.pow(10, places); }

    }
  };

  Drupal.behaviors.clearResult = {
    attach(context,settings) {
      try {
        $('#bmi-weight-input', '#bmi-height1', '#bmi-height2').onfocus(function() {
          document.getElementById('bmi-results').style.visibility = 'hidden';
        });
      }
      catch (e) { /* Do nothing when onFocus is not defined. */ }
    }
  };

  Drupal.behaviors.weightUnitsCheck = {
    attach(context,settings) {
      $('#weightUnits').change(function() {
        document.getElementById('bmi-results').style.visibility = 'hidden';
      });
    }
  };

  Drupal.behaviors.heightUnitsCheck = {
    attach(context,settings) {
      $('#heightUnits').change(function() {
        document.getElementById('bmi-results').style.visibility = 'hidden';
        let unit = eval(document.form.heightUnits.selectedIndex);
        if (unit == 0) { document.getElementById('bmi-height2').style.visibility = 'visible';
          document.getElementById('bmi-heightLabel2').style.visibility = 'visible';
        }
        if (unit == 1)
        { document.getElementById('bmi-height2').style.visibility = 'hidden';
          document.getElementById('bmi-heightLabel2').style.visibility = 'hidden';
        }
      });
    }
  };

})(jQuery, Drupal);
